import { combineReducers, Reducer } from "redux";
import { PURGE } from "redux-persist";
import axios from "axios";
import { RootState as RT } from "./state";
import { authReducer, UNAUTHORIZED } from "./auth";
import { noteReducer } from "./notification";
import { Reducer as userReducer } from "./user";
import { Reducer as menuReducer } from "./menu";
import { Reducer as ScheduleReducer } from "./schedule";
import { Reducer as PrescriptionReducer } from "./prescription";
import { Reducer as DrugReducer } from "./drug";
import { Reducer as InvReducer } from "./invitation";
import { Reducer as DocReducer } from "./documents";
import { Reducer as LocaReducer } from "./location";
import { Reducer as specialtyReducer } from "./specialty";
import { Reducer as collectDocumentReducer } from "./collectDocument";
import { Reducer as appointmentTypeReducer } from "./appointmentType";
import { Reducer as socketReducer } from "./socket";
import { Reducer as filesReducer } from "./files";
import { Reducer as messagingReducer } from "./messaging";
import { Reducer as doctorReducer } from "./doctor";
import { Reducer as billingReducer } from "./billing";
import { Reducer as eventsReducer } from "./events";
import { Reducer as procedureReducer } from "./procedure";
import { Reducer as appointmentInstructionReducer } from "./appointmentInstruction";
import { Reducer as immediateCareReducer } from "./immediateCare";
import { Reducer as realtimeReducer } from "./realtime";
import { Reducer as doctorReviewReducer } from "./doctorReview";

export type RootState = RT;

export interface Action {
  type: string;
  payload: any;
}

export const reducers: Reducer<RootState> = combineReducers<RootState>({
  auth: authReducer,
  notification: noteReducer,
  user: userReducer,
  menu: menuReducer,
  schedule: ScheduleReducer,
  prescription: PrescriptionReducer,
  drug: DrugReducer,
  invitation: InvReducer,
  documents: DocReducer,
  location: LocaReducer,
  specialty: specialtyReducer,
  collectDocument: collectDocumentReducer,
  appointmentType: appointmentTypeReducer,
  socket: socketReducer,
  files: filesReducer,
  messaging: messagingReducer,
  doctor: doctorReducer,
  billing: billingReducer,
  events: eventsReducer,
  procedure: procedureReducer,
  appointmentInstruction: appointmentInstructionReducer,
  immediateCare: immediateCareReducer,
  realtime: realtimeReducer,
  doctorReview: doctorReviewReducer,
});

axios.defaults.headers = {
  "Content-Type": "application/json",
};

export const rootReducer = (state: RootState, action: any) => {
  if (action.type === UNAUTHORIZED) {
    state = reducers(state, { type: PURGE });
  }

  return reducers(state, action);
};

export type Error = any;
